import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { AppContext } from '@prisjakt/ui-app-context';
import { bemGenerator } from '@prisjakt/ui-base';
import { Checkbox } from '@prisjakt/ui-inputs';
import PanelHeader from '@prisjakt/ui-panel-header';

import alertSettingsActions from '../../actions/alert-settings';

import './index.scss';

const styles = bemGenerator('settings-alert', ['setting']);

const notificationTypes = props => {
  const types = ['email'];

  if (props.hasActivePushTokens) {
    types.push('push');
  }

  return types;
};

const AlertSettings = props => {
  const { t } = useContext(AppContext);
  return (
    <div className={styles.block}>
      <PanelHeader title={t('alerts', 'settings.header')} margin="bottom" />
      <p>{t('alerts', 'settings.notify-by')}</p>
      {notificationTypes(props).map(type => (
        <div className={styles.setting} key={type}>
          <Checkbox
            name={`alert_method_${type}-${props.shouldSave}`}
            checked={props.alertSettings[type]}
            onChange={() => {
              if (props.shouldSave) {
                props.alertSettingsChangeRequest({
                  setting: type,
                  value: !props.alertSettings[type],
                });
              } else {
                props.alertSettingsChange({
                  setting: type,
                  value: !props.alertSettings[type],
                });
              }
            }}
          >
            {t('alerts', `settings.notify-by-${type}`)}
          </Checkbox>
        </div>
      ))}
    </div>
  );
};

AlertSettings.propTypes = {
  hasActivePushTokens: PropTypes.bool,
  alertSettings: PropTypes.shape({
    email: PropTypes.bool,
    push: PropTypes.bool,
  }),
  alertSettingsChange: PropTypes.func,
  alertSettingsChangeRequest: PropTypes.func,
  shouldSave: PropTypes.bool,
};

AlertSettings.defaultProps = {
  hasActivePushTokens: false,
  alertSettings: PropTypes.shape({
    email: false,
    push: false,
  }),
  alertSettingsChange: () => {},
  alertSettingsChangeRequest: () => {},
  shouldSave: true,
};

export default connect(
  state => state.areas.account.me,
  alertSettingsActions
)(AlertSettings);
